import { render, staticRenderFns } from "./helpMenu.vue?vue&type=template&id=79e61bae"
import script from "./helpMenu.vue?vue&type=script&lang=js"
export * from "./helpMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports